import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Plus } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogClose,
  Button,
} from '@scio3/ui';
import { useBillingDialogStore } from '../stores/billing-dialog-store';
import { ADDON_DISPLAY_NAMES } from '../utils/billing-constants';

export function AddonRequiredDialog() {
  const { t } = useTranslation();
  const activeDialog = useBillingDialogStore((s) => s.activeDialog);
  const dialogContext = useBillingDialogStore((s) => s.dialogContext);
  const openDialog = useBillingDialogStore((s) => s.openDialog);
  const closeDialog = useBillingDialogStore((s) => s.closeDialog);

  const addonType = (dialogContext.addonType as string) ?? '';
  const addonName = ADDON_DISPLAY_NAMES[addonType] ?? addonType;

  const handleUpgrade = useCallback(() => {
    openDialog('subscriptionWizard', {
      addonMode: true,
      addonType,
    });
  }, [openDialog, addonType]);

  const isOpen = activeDialog === 'addonRequired';

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && closeDialog()}>
      <DialogContent
        className="max-h-[85vh] flex flex-col overflow-hidden sm:max-w-sm"
        data-testid="addon-required-dialog"
      >
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Plus className="h-5 w-5 text-primary" />
            {t('Add-on Required')}
          </DialogTitle>
        </DialogHeader>

        <div className="flex-1 overflow-y-auto py-4">
          <p className="text-sm text-muted-foreground">
            {t('This feature requires the {{addon}} add-on', { addon: addonName })}
          </p>
        </div>

        <DialogFooter>
          <DialogClose asChild>
            <Button variant="ghost" className="cursor-pointer">
              {t('Cancel')}
            </Button>
          </DialogClose>
          <Button onClick={handleUpgrade} className="cursor-pointer">
            {t('Upgrade')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
